// this is the entry point
import react, { filters } from '../dist/react.esm';

export { info } from '../dist/info';

export { react, filters };
